import { EskatAction, SET_ESKAT_API_STATUS } from '../types/eskatTypes';
import { ApiStatus } from '../types/sharedTypes';

interface EskatState {
  readonly apiStatus: ApiStatus;
}

const eskatInitialState: EskatState = Object.freeze({
  apiStatus: ApiStatus.Idle,
});

const eskatReducer = (
  state = eskatInitialState,
  action: EskatAction
): EskatState => {
  switch (action.type) {
    case SET_ESKAT_API_STATUS:
      return { ...state, apiStatus: action.payload };

    default:
      return state;
  }
};

export default eskatReducer;
